/* eslint-disable */

import React from 'react';
import classNames from 'classnames/bind';
import styles from './RefundWarranty.module.scss';

const cx = classNames.bind(styles);

function RefundWarranty_04() {
	return (
		<div className={cx('terms')}>
			<h3 className={cx('tit_terms', 'pt0')}>1. 서비스 소개</h3>
			<p className={cx('cont_terms')}>
				“엔카보증”은 엔카닷컴 주식회사(이하 “엔카”)가 제공하는 중고차 보증수리 서비스로, 당사 직영 또는 제휴 성능장에서 점검한 차량에 한해,
				차량 구매 후 발생하는 고장에 대해 당사 책임 하에 보증수리를 진행하는 서비스입니다.
			</p>

			<h3 className={cx('tit_terms')}>2. 효력의 발생 및 보증기간</h3>
			<p className={cx('cont_terms')}>
				본 상품의 효력은 상품의 구매일부터 즉시 발효됩니다. 엔카보증 3개월 상품의 경우, 구매일로부터 90일, 또는 약정거리로부터 5,000km 중 먼저
				도래하는 날까지 보증 받으실 수 있습니다. 엔카보증 6개월 상품의 경우, 구매일로부터 180일 또는 약정거리로부터 10,000km 중 먼저 도래하는
				날까지 보증 받으실 수 있습니다. (보증기간 기산은 주말과 공휴일을 포함합니다.)
				<br />※ 보증서에 기입된 보증 시작 주행거리는, 차량의 광고등록 시점의 주행거리로 매매계약 시 차량의 실제 주행거리와 다소 차이가 있을 수
				있습니다. (20km 이내, 광고 등록 후 매매단지로의 이동 등의 사유) 이 경우 보증서에 기입된 주행거리를 기준으로 보증기간을 계산합니다.
			</p>

			<h3 className={cx('tit_terms')}>3. 보증범위 및 책임한도</h3>
			<ul className={cx('cont_terms')}>
				<li>
					1) 제조사에서 교부한 차량 관리/이용설명서에 따라 정상적으로 관리된 상태를 전제로, 엔카에서 정의한 보증기간 내에 해당되고, 보증거리
					미만인 자동차에 한하여 엔진, 트랜스미션, 제동장치, 일반부품의 고장 시, 해당 부품을 엔카의 비용으로 수리하여 드립니다. (자기부담금
					제외)
				</li>
				<li>
					2) 당사는 보증부품의 고장에 대하여 수리, 정비 및 교환에 대한 의무만을 가지며, 이외의 어떠한 부분에 대해서도 책임과 의무를 지지
					않습니다.
				</li>
				<li>
					※ 단 엔카가 규정하는 보증부품의 고장이나 성능이상을 차량 제조사 보증을 이용하여 수리하는 경우, 렌트비 또는 교통비(교통비의 경우,
					일 3만원 한도)를 지원해 드립니다. 실 수리소요 기간에 한해 렌트비, 교통비를 지원하므로 수리견적서 및 렌트카 계약서 등 증빙 제출
					필요 (렌트의 경우 최대 기간 30일, 최대 국산 중형에 한함)
				</li>
				<li>
					3) 차량 구매일로부터 7일 내, 아래 부품에 대한 클레임은 엔카에서 보상하지 않습니다.
					<br />- 등화류 / 공조기(에어컨, 히터) / 네비게이션 작동유무 / 하부 소음 관련 부품 / 계기판 경고등으로 알 수 있는 문제
				</li>
			</ul>
			<h3 className={cx('tit_terms')}>4. 보증한도</h3>
			<p className={cx('cont_terms')}>
				보증한도는 고객님의 자기부담금을 제외하고, 누적 보증수리 비용을 기준으로 엔카보증 3개월 상품의 경우 300만원이고, 엔카보증 6개월 상품의
				경우 500만원이며, 이를 초과하는 비용은 고객님이 부담하셔야 합니다.
				<br />
				보증 기간 내 또는 보증 거리 미만인 경우에도 보증한도가 초과되면, 그 시점을 보증의 조기종료 시점으로 간주합니다.
			</p>

			<h3 className={cx('tit_terms')}>5. 자기부담금</h3>
			<p className={cx('cont_terms')}>
				고객님의 보증수리 요청 시, 자기부담금이 발생합니다. 자기부담금은 보증항목에서 정의한 부품 단위로 발생하고, 건당 5만원입니다.
				자기부담금 지급을 거절하는 경우 보증수리가 불가합니다.
				<br />※ 보증수리를 진행하지 않더라도 이상증상 확인 등의 과정에서 최대 5만원의 점검비가 발생할 수 있습니다. 발생 점검비 지급을 거절하는
				경우 점검이 불가합니다.
			</p>

			<h3 className={cx('tit_terms')}>6. 보증항목</h3>
			<p className={cx('cont_terms')}>엔카는 아래 열거된 부품에 대해서만 보증 수리를 제공합니다.</p>
			<ul className={cx('cont_terms')}>
				<li>
					1)엔진
					<br />
					실린더블록 및 내부구성품, 크랭크샤프트, 로드 및 메인베어링, 캠베어링, 익스팬션 플러그, 피스톤 및 피스톤링, 커넥팅로드, 캠샤프트,
					실린더 헤드, 밸브 및 가이드, 밸브스프링, 로커암 및 푸쉬로드, 폴리, 타이밍체인 및 스프라켓, 타이밍체인 하우징, 흡/배기 매니폴드,
					플라이휠, 밸런스샤프트, 하모닉밸런스 및 리테이너 볼트, 크랭크 샤프트폴리, 오일팬, 오일펌프, 오일펌프 및 프레셔 릴리브밸브,
					엔진오일쿨러, 오일필터 어댑터 및 하우징, 워터펌프, 써모스탯 및 하우징, 연료공급펌프, 진공펌프, 오일레벨게이지 및 튜브,
					바이패스밸브, 인젝션 펌프
				</li>
				<li>
					2)미션
					<br />
					내부디스크(오토), 드라이브 플레이트(오토), 드럼 기어세트, 메인샤프트 및 기어세트, 미션케이스 및 내부구성품, 밴드, 밸브바디, 부싱,
					샤프트, 솔레노이드 밸브, 시프트포크, 싱크로나이져링, 오일 레벨게이지 및 튜브, 오일펌프, 오토미션 전용쿨러, 토크컨버터,
					트랜스퍼케이스 및 내부구성품
				</li>
				<li>
					3)제동장치
					<br />
					ABS 모듈, 부스터, 캘리퍼, 마스터/휠 실린더, 브레이크 호스, EPB(전자식주차브레이크)
				</li>
				<li>
					4)일반부품
					<br />
					ECU, EGR 밸브, ETACS/BCM, TCU, 고압/저압호스, 고압펌프, 과급기, 냉각팬/컨덴서팬, 도어관련부품(윈도우모터 및 기어, 도어엑츄에이터),
					등속조인트, 라디에이터(팬, 팬모터), 리저브 탱크류, 릴레이, 모듈류, 미션체인지레버 관련부품, 믹서, 발전기, 베이퍼라이저,
					블로우모터(모드 엑츄에이터, 템퍼레이쳐센서), 순정오디오(스피커, 핸들리모컨, 순정앰프), 순정네비게이션, 스로틀바디,
					스티어링기어/MDPS(기어링키지, 컬럼샤프트, 유니버션조인트, 파워렉, 피니언, 타이로드앤드, 파워스티어링 오일펌프, 리저브, 파워호스,
					EPS센서), 시동모터, 시동키 관련부품(카레스 리시버, 안테나.컨트롤러), 안전벨트 관련부품, 액슬축, 에바포레이터, 에어백 관련부품,
					에어컨 관련 부품(에어컨컴프, 폴리, 파이프, 호스, 에어컨콘덴서, 리시버탱크, 익스팬션밸브, O링류), 엔진 아이들러/텐셔너, 엔진코일,
					연료인젝터, 와이어링하네스, 와이퍼모터(워셔펌프), 완충기(어퍼암, 로어암, 볼조인트, 쇽업쇼바, 스테빌라이져, 트레일링암,
					하부암컴플리트, 스트러트브라켓, 허브베어링, 휠 허브/너클, 코인스프링), 인터쿨러, 차동장치/액슬하우징, 트렁크/본넷쇼바, 파워펌프,
					허브베어링, 히터코어(서미스터, 히터콘트롤유닛, 히터모터, 히터팬)
				</li>
			</ul>
			<br />
			<p>※ 단순 노후화에 따른 하체 부싱류 보증 불가</p>

			<h3 className={cx('tit_terms')}>7. 보증 제외 사항</h3>
			<p className={cx('cont_terms')}>보증기간이 만료되지 않았더라도 아래 사항에 해당하는 경우 보증수리가 불가합니다.</p>
			<ul className={cx('cont_terms')}>
				<li>1) 제조사의 차량 관리, 사용 지침을 따르지 않아 발생하는 고장</li>
				<li>2) 설계 결함, 차량 제작 오류, 부품 자체 결함으로 발생하는 고장</li>
				<li>3) 제조사의 배출가스 규제 관련 부품, 서비스 캠페인, 리콜 캠페인 등 소비자 지원 프로그램에서 지원하는 항목에 대한 고장</li>
				<li>4) 자동차의 성능 및 안전에 영향을 줄 수 있다고 인정되는 변형 및 개조에 의한 고장</li>
				<li>5) 보증 제외 부품의 고장 및 손상을 원인으로 하는 보증부품의 고장</li>
				<li>6) 일반적인 품질 및 기능상 영향이 없다고 인정되는 감각적, 주관적 불만사항 (이음, 잡음, 소음, 진동, 냄새, 외관, 주행감각 등)</li>
				<li>7) 고의 또는 사고나 도난으로 인해 발생한 고장</li>
				<li>8) 화재, 천재지변 등에 의한 고장</li>
				<li>9) 부적절한 부품의 사용 또는 수리 지연 등에 의해 발생하는 고장</li>
				<li>10) 정상적인 주행환경이 아닌 상황에서 발생한 고장(산악주행, 써킷주행 등)</li>
				<li>11) 부품, 공임 등 직접 비용을 제외한 교통비, 운반비, 운휴손실비, 유류비 및 기타 비용 일체</li>
				<li>12) 주행거리 임의변조로 정확한 주행거리를 확인할 수 없는 경우</li>
				<li>13) 당사의 절차를 따르지 않고 임의로 분해 및 수리한 경우</li>
				<li>14) 딜러의 고지, 성능상태점검기록부 등으로 차량 구매 전 미리 인지한 차량의 이상 및 증상</li>
				<li>
					15) 중고차 특성상 발생할 수 있는 미세누유
					<br />
					&nbsp;&nbsp;* 누유: 1시간 이상 운행 후, 해당 부위 점검 시 맑은 오일이 새어 나와 맺히는 경우 또는 오일이 5cm 이상의 넓은 범위로
					새어 묻어 나오는 경우를 정의하며, 상기 외 어떠한 경우에 대해서도 보증 책임 및 의무를 지지 않습니다.
				</li>
			</ul>

			<h3 className={cx('tit_terms')}>8. 가입자 의무</h3>
			<p className={cx('cont_terms')}>본 상품을 구매한 고객님께도 다음과 같은 의무가 있습니다.</p>
			<ul className={cx('cont_terms')}>
				<li>
					1) 수리 소요가 발생하는 상황에 대해 올바른 사실을 엔카에 고지하셔야 합니다. 고지 사실과 다르게 고객님의 고의나 과실, 보증 가능
					주행거리 초과가 확인될 경우, 보증수리가 불가합니다.
				</li>
				<li>
					2) 문제 발생 시, 문제의 증상과 부품을 정확히 엔카에 고지해야 합니다. 고지하신 문제의 증상이나 부품 이외의 내용은 보증수리가
					불가합니다.
				</li>
			</ul>

			<h3 className={cx('tit_terms')}>9. 서비스 이용절차 및 제한사항</h3>
			<ul className={cx('cont_terms')}>
				<li>
					1) 서비스 이용절차
					<ul>
						<li>
							① 클레임 접수 및 수리이력 관리를 위해 엔카닷컴 홈페이지(www.encar.com) 회원가입 후 마이페이지에서 보증등록을 권장합니다.
						</li>
						<li>
							② 정상 업무시간 내 보증수리 문의전화번호로 접수 후, 엔카가 지정한 정비업체로 차량을 입고하여 보증 적용 여부를 확인 받아야
							합니다.
							<br />
							(정상업무시간: 평일 09:30~12:00, 13:00~18:30)
							<br />※ 보증만료일이 공휴일인 경우 그 익일까지 유효함
						</li>
						<li>③ 보증담당자의 요청이 있을 경우, 주행거리 계기판 사진을 지정한 곳으로 보내주어야 합니다.</li>
						<li>
							④ 보증수리 접수일로부터 7일 이내 지정 정비업체로 입고 및 확인 절차가 이루어져야 하며 입고일이 접수일로부터 7일 이 초과되는
							경우 보증수리가 거부될 수 있습니다. 보증수리 거부 시, 재접수가 필요하고, 재접수일 기준으로 보증약정일 또는 약정주행거리를
							적용합니다.
						</li>
					</ul>
				</li>
				<li>
					2) 주의 사항
					<ul>
						<li>
							① 본 보증 서비스는 엔카의 날인이 있는 보증서를 온라인 또는 오프라인으로 보유하고 있거나, 엔카닷컴 사이트에 정상적인 절차로
							보증 등록을 마친 경우에만 유효합니다.
						</li>
						<li>② 보증수리는 엔카가 지정한 정비업체에 한해서만 가능합니다.</li>
						<li>
							③ 고객이 보증수리를 받고자 할 경우, 보유한 보증서와 서명날인된 성능점검기록부를 지참하여 엔카가 지정하여 차량 입고 예정인
							정비소에 제시해야 합니다.
						</li>
						<li>④ 보증수리 교체부품은 재생품, 중고품 사용을 원칙으로 합니다.</li>
						<li>⑤ 보증수리는 대표번호 02-754-5715로 접수된 경우만을 인정합니다.</li>
					</ul>
				</li>
				<li>
					3) 차량 소유주의 본인 접수 원칙
					<br />
					보증수리 접수는 차주 본인의 직접 접수를 원칙으로 합니다. 단, 정당한 사유로 본인 접수가 어려운 경우, 대리 접수 가능하며 보증
					담당자의 요청에 따라 위임장, 접수자 신분증, 차량 소유주 신분증 등의 서류를 제출해야 합니다.
				</li>
				<li>
					4) 차량 구매 시 사전 고지된 사항
					<br />
					보증품목과 관련하여 구매 당시에 사전 고지된 부품의 상태는 차량 가격에 반영되어 있으며, 해당 부품에 대해 추가로 보증수리를 하고자
					할 경우에는 보증품목이라 할 지라도 보증수리가 불가합니다. 단, 사전 고지된 사항에 대해 본인 부담으로 수리하여 상당 기간 정상 운행한
					후 수리가 필요해진 경우, 본인 부담으로 수리한 이력을 엔카에 제시하면 보증수리가 가능합니다.
				</li>
			</ul>

			<h3 className={cx('tit_terms')}>10. 서비스 가입 철회 및 환불</h3>
			<p className={cx('cont_terms')}>
				1) 환불 원칙
				<br />
				고객님께서 차량을 인수한 시점으로부터 주행을 시작함과 동시에 여러 외부적인 위험 요소에 대해 보증효력이 발생하기 때문에 차량 인수
				후에는 보증 연장 상품의 환불이 원칙적으로 불가합니다.
				<br />
				단, 구매일로부터 7일 내 요청 시 철회가 가능하며 이 때 전체 금액을 환불해 드립니다.
				<br />
				구매일로부터 7일 이후에 철회를 요청하는 경우, 보증 수리 이력이 없는 경우에 한하여 철회 가능합니다. 다만, 이 경우
				취소수수료(정액취소수수료 + 보증비 일할계산분)가 발생합니다.
				<br />① 정액취소수수료: 3개월 상품 - 55,000원 / 6개월 상품 - 100,000원
				<br />② 보증비 일할계산식: 차종별 3개월 상품 가격 &divide; 90일 x 실제 보증일수
				<br />※ 6개월 상품에 가입하는 경우에도, 환불 시에는 ②의 계산식이 적용됩니다. (6개월 상품의 경우, 가입 시 보증 유지를 전제로 할인이
				적용되는데, 환불 시에는 할인혜택 적용 불가하기 때문)
			</p>
		</div>
	);
}

export default RefundWarranty_04;
